import { createContext } from "react";

const SocketAppContext = createContext();

export default SocketAppContext;
